import { useEffect, useState } from "react";
import MultiApprovalGif from "../../../assets/landingPage/Approval.gif";
import ICONS from "../../../assets/Icons";

const UniSecCarosel = () => {
  const sections = [
    {
      title: "Security",
      description:
        "Xpentra ensures the highest level of security with multi-factor authentication, encryption, and audit trails, safeguarding your financial data and transactions at every step.",
      image: ICONS?.SECURITY_CENTER,
    },
    {
      title: "Unified Financial Management",
      description:
        "Xpentra brings all your banking and financial operations-payments, balances, reconciliation, and more- into one streamlined platform, simplifying workflows and boosting efficiency.",
      image: ICONS?.UNIFIED_DASHBOARD,
    },
    {
      title: "Advanced Analytics",
      description:
        "Our platform provides real-time analytics and customizable reports, offering deep insights into transaction data, cash flow, and performance to support smarter, data-driven decisions.",
      image: ICONS.ADVANCED_ANALYTICS,
    },

    {
      title: "Authorization Matrix",
      description:
        "The customizable authorization matrix allows you to define roles, permissions, and approval workflows, ensuring that only authorized personnel have access to critical financial actions.",
      image: ICONS?.AUTHORIZATION_MATRIX_LIGHT_BLUE,
    },
  ];
  const desktopSections = [
    sections[1], 
    sections[2],
    sections[0],
    sections[3]
  ];
  // useState
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [pausedTransform, setPausedTransform] = useState(null);
  const intervalTime = 2000;

  const handleMouseOver = () => {
    setIsPaused(true);
    const currentTransform = `translateX(- ${currentIndex * (300 + 20)}px)`;
    setPausedTransform(currentTransform);
  };
  const handleMouseOut = () => {
    setIsPaused(false);
    setPausedTransform(null);
  };

  // useEffect
  useEffect(() => {
    const interval = setInterval(() => {
      if (!isPaused) {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % sections.length);
      }
    }, intervalTime);

    return () => clearInterval(interval);
  }, [isPaused, sections.length]);

  return (
    <div className="bg-[#031F4F] px-0 pt-[50px] pb-5 lg:p-[30px]">
      <div className="max-w-[1024px] mx-auto rounded-[15px] lg:bg-[#3A5686] flex
        flex-col lg:flex-row gap-4 lg:gap-0"
      >
        <div className="flex flex-col lg:bg-[rgb(58, 86, 134)] lg:rounded-l-[15px]">
          <div className="lg:text-font-xl lg:pl-[30px] lg:py-[77px] lg:max-w-[300px] 
            lg:h-[230px] lg:rounded-tl-[15px]"
          >
            <p className="text-left font-['Open_Sans'] font-semibold text-text-primary
              pl-[5px] xs:pl-[30px] Qlg:pl-[0px] lg:text-[28px] lg:leading-[38px]"
            >
              What makes us <span className="text-pending">unique?</span>
            </p>
          </div>

          {/* Desktop Left Cards */}
          <div className="hidden lg:flex">
            {desktopSections.slice(0, 2).map((section, index) => (
              <div
                key={index}
                className={`flex flex-col gap-2.5 h-[230px] max-w-[205px] py-[20px] pl-[15px] ${
                  index === 0 || index === 4
                    ? "bg-[#102C5D] rounded-bl-[15px] pr-[5px]"
                    : index === 1 || index === 3
                      ? "bg-[#244277] pr-[10px]"
                      : "bg-[#1D3A6D]"
                  }
                }`}
              >
                <div className="h-[60px] w-[60px] rounded-[50%]">
                  <img
                    className="h-[60px] w-[60px]"
                    src={section.image}
                    alt={section.title}
                  />
                </div>

                <div className="flex flex-col gap-2.5">
                  <p className="text-text-primary text-font-xs font-semibold">
                    {section.title}
                  </p>

                  <p className="text-text-primary text-font-xxs font-normal">
                    {section.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* GIF */}
        <div className="max-w-[300px] lg:max-w-[100%] mx-auto rounded-[10px] lg:flex">
          <div
            className="rounded-t-[10px] lg:rounded-none lg:h-[460px] lg:max-w-[409px]
              lg:text-center lg:flex lg:bg-[#1D3A6D] lg:pt-[20px] lg:pr-[23px] lg:pb-[19px] 
              lg:pl-[22px]"
          >
            <img
              src={MultiApprovalGif}
              alt="Multi Approve"
              className="rounded-[10px] w-[600px] lg:opacity-100"
            />
          </div>
        </div>
        {/* Desktop Right Cards */}
        <div className="hidden lg:block">
          {desktopSections.slice(2, 4).map((section, index) => (
            <div
              key={index}
              className={`flex flex-col gap-2.5 h-[230px] max-w-[205px] py-[20px] pl-[15px] pr-[5px] ${
                index === 0
                  ? "bg-[#244277] rounded-tr-[15px]"
                  : "bg-[#102C5D] rounded-br-[15px]"
              }`}
            >
              <div className="h-[60px] w-[60px] rounded-[50%]">
                <img
                  className="h-[60px] w-[60px]"
                  src={section.image}
                  alt={section.title}
                />
              </div>

              <div className="flex flex-col gap-2.5">
                <p className="text-text-primary text-font-xs font-semibold">
                  {section.title}
                </p>

                <p className="text-text-primary text-font-xxs font-normal">
                  {section.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Mobile Carousel */}
        <div className="lg:hidden">
          <div className="w-[300px] mx-auto">
            {/* Cards */}
            <div className="overflow-hidden h-[218px] rounded-[10px] relative">
              <div
                className="flex gap-[20px]"
                style={{
                  transform: isPaused
                    ? pausedTransform
                    : `translateX(-${currentIndex * (300 + 20)}px)`,
                  transition: isPaused
                    ? "none"
                    : "transform 700ms ease-in-out",
                }}
                onMouseOver={handleMouseOver}
                onMouseOut={handleMouseOut}
              >
                {sections.map((section, index) => (
                  <div
                    key={index}
                    className={`max-w-[300px] w-[300px] h-[218px] flex-shrink-0
                      p-[20px] rounded-[10px]
                      ${
                        index % 2 === 0
                          ? "bg-[rgba(16,44,93)]"
                          : "bg-[rgba(36,66,119)]"
                      }
                    `}
                  >
                    <div className="flex flex-col gap-[10px]">
                      <div
                        className={`
                          h-[40px] w-[40px] rounded-[50%]
                          ${
                            index % 2 === 0
                              ? "bg-[rgba(36,66,119)]"
                              : "bg-[rgba(16,44,93)]"
                          }
                        `}
                      >
                        <img
                          className="h-[40px] w-[40px]"
                          src={section.image}
                          alt="Icon"
                        />
                      </div>

                      <div className="text-font-md font-semibold text-text-primary">
                        {section.title}
                      </div>

                      <div className="text-font-xs font-normal text-text-primary">
                        {section.description}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Indicators */}
            <div className="max-w-[230px] mx-auto mt-[10px] flex gap-[10px] justify-center">
              {sections.map((_, index) => (
                <div
                  key={index}
                  className={`
                    rounded-[18px]
                    bg-text-primary
                    h-[4px]
                    transition-all
                    duration-500
                    ease-in-out
                    ${
                      index === currentIndex
                        ? "w-[80px] opacity-100"
                        : "w-[40px] opacity-50"
                    }
                  `}
                />
              ))}
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default UniSecCarosel;
